enum IFileRoleEnum {
  RAW = 'RAW',
  ANALYSIS_RESULT = 'ANALYSIS_RESULT',
  REPORT_FILE = 'REPORT_FILE',
}

export default IFileRoleEnum;
